import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M10.74 20.88c-1.44 0-2.6 1.14-2.6 2.55s1.16 2.55 2.6 2.55c1.44 0 2.6-1.14 2.6-2.55 0-1.4-1.16-2.55-2.6-2.55zm0 3.72c-.65 0-1.19-.52-1.19-1.17 0-.64.53-1.17 1.19-1.17.65 0 1.19.52 1.19 1.17 0 .65-.53 1.17-1.19 1.17zM22.96 20.88c-1.44 0-2.6 1.14-2.6 2.55s1.16 2.55 2.6 2.55c1.44 0 2.6-1.14 2.6-2.55.01-1.4-1.16-2.55-2.6-2.55zm0 3.72c-.65 0-1.19-.52-1.19-1.17 0-.64.53-1.17 1.19-1.17.65 0 1.19.52 1.19 1.17 0 .65-.53 1.17-1.19 1.17zM26.61 13.54H6.28c0 4.27 4.55 7.72 10.16 7.72s10.17-3.45 10.17-7.72zM6.36 12.67h1.18v-1.66c0-2.69-2.3-3.51-3.51-3.57a.59.59 0 0 0-.62.55c-.01.32.24.59.56.61.25.01 2.39.2 2.39 2.42v1.65zM18.91 4.73c-1.55-.01-3.47 7.94-3.47 7.94h11.14c-.23-5.24-4.2-7.93-7.67-7.94z" })
    ], -1)
  ])))
}
export default { render };